import * as React from "react";
import { CompanyWizardAction } from "../../../../Admin/Company/CompanyWizard/Actions/CompanyWizardAction";
import { CompanyServicePropositionStore } from "../../../../Admin/Company/CompanyWizard/Stores/Variable";
import { RadioGroup } from "../../../../../react-core/Html/RadioGroup";
import { Objects } from "../../../../../react-core/Utils/Objects";
import { IProcessComponentProps, ProcessComponent } from "../../../../Shared/Process/Process/ProcessComponent";
import { ServiceProposition } from "../../../../../Wrap/Constants/Enums/ServiceProposition";
import { ServicePropositionMap } from "../../../../Shared/Entities/Maps/ServicePropositionMap";
import { SectionHeader } from "./SharedComponents";

interface IServicePropositionSelectionProps extends IProcessComponentProps {
    actorId: number;
    selectedPropositionId: number;
    disable: boolean;
}

interface IServicePropositionSelectionState {
    availablePropositions: Array<ServiceProposition>;
}

export class ServicePropositionSelection extends ProcessComponent<
    IServicePropositionSelectionProps,
    IServicePropositionSelectionState
> {
    constructor(props: any) {
        super(props);
        this.state = this.getDefaultState();
        this.subscribeToStore(CompanyServicePropositionStore, () => this.onCompanyWizardStoreChange());
    }

    private getDefaultState() {
        const availablePropositions = CompanyServicePropositionStore.getData();
        return {
            availablePropositions: availablePropositions,
        } as IServicePropositionSelectionState;
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.props.actorId != null) {
            CompanyWizardAction.getCompanyServicePropositions(this.props.actorId);
        }
    }

    componentWillReceiveProps(nextprops: IServicePropositionSelectionProps) {
        if (nextprops.actorId != this.props.actorId && nextprops.actorId != null) {
            CompanyWizardAction.getCompanyServicePropositions(nextprops.actorId);
        }
        if (
            nextprops.selectedPropositionId === this.props.selectedPropositionId &&
            this.props.selectedPropositionId === undefined
        ) {
            const propositions = this.getPropositions();
            if (propositions.length === 1) {
                this.props.onChange({ AccountServiceProposition: propositions[0] });
            }
        }
    }

    private onCompanyWizardStoreChange() {
        const availablePropositions = CompanyServicePropositionStore.getData();
        this.updateStatePart((x) => {
            x.availablePropositions = availablePropositions;
        });
    }

    private getPropositions() {
        let propositions = this.state.availablePropositions
            ? Objects.cloneObject(this.state.availablePropositions)
            : [];

        if (propositions.includes(ServiceProposition.NonWrapEnabled)) {
            propositions = [].concat(ServiceProposition.Wrap);
        }

        return propositions;
    }

    render() {
        const propositions = this.getPropositions();

        return (
            <>
                <div>
                    {SectionHeader("Service proposition type")}
                    <RadioGroup
                        // tooltip={"Selection of client service proposition type"}
                        options={propositions.map((ele) => ele)}
                        getText={(option) => ServicePropositionMap.getString(propositions.find((x) => x == option))}
                        selected={this.props.selectedPropositionId}
                        onChange={(value) => this.props.onChange({ AccountServiceProposition: value })}
                        required={"Please select a service proposition type"}
                        disabled={this.props.disable || propositions.length === 1}
                    />
                </div>
            </>
        );
    }
}
